import React from 'react';
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
function SingleValue(props) {
   const indicadorTitulos = props.selectProps.titulos;
   return (
      <Typography
         title={indicadorTitulos ? props.children : undefined}
         variant="body1"
         className={props.selectProps.classes.singleValue}
         style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}
         {...props.innerProps}
      >
         {props.children}
      </Typography>
   );
}

SingleValue.propTypes = {
   /**
    * The children to be rendered.
    */
   children: PropTypes.node,
   /**
    * Props passed to the wrapping element for the group.
    */

   innerProps: PropTypes.any,
   selectProps: PropTypes.object.isRequired
};
export default SingleValue;
